import type { Message } from "~/helpers/aiChat/chatStorage";
import type { AnswerRating, RatingDetails, RatingReasonCategory } from "~/services/aiOrchestrator";

const REASON_MAX_LENGTH = 1000;

const REASON_CATEGORIES: RatingReasonCategory[] = [
	"WRONG",
	"DID_NOT_ANSWER",
	"COULD_NOT_DO",
	"UNHELPFUL_REDIRECT",
	"OTHER"
];

const buildRateInput = (
	sessionId: string,
	messageId: string,
	rating: AnswerRating | null,
	details?: RatingDetails
) => ({
	messageId,
	rating,
	sessionId,
	...(details && {
		followUpRequested: details.followUpRequested,
		reason: details.reason || undefined,
		reasonCategory: details.category
	})
});

const canRateAnswer = (message: Message): boolean =>
	message.role === "assistant" &&
	message.serverId !== undefined &&
	!message.proposals?.length &&
	!message.intakeDrafts?.length &&
	message.navConfirmation === undefined;

const nextRating = (current: AnswerRating | undefined, picked: AnswerRating): AnswerRating | null =>
	current === picked ? null : picked;

const shouldAskReason = (isSaved: boolean, picked: AnswerRating, previous: AnswerRating | undefined): boolean =>
	isSaved && picked === "DOWN" && previous !== "DOWN";

const isNewServerAnswer = (messages: Message[], answerId: string): boolean =>
	!messages.some((message) => message.serverId === answerId);

const answerRating = {
	buildRateInput,
	canRateAnswer,
	isNewServerAnswer,
	nextRating,
	REASON_CATEGORIES,
	REASON_MAX_LENGTH,
	shouldAskReason
};

export default answerRating;
